import {
    CLEAR_ORDER_ITEM_START,
    CLEAR_ORDER_ITEM_SUCCESS,
    CLEAR_ORDER_ITEM_ERROR
} from '../../constants';
import { clearOrderedItems as mutation, getOrder as query } from '../../lib/graphql';

export function clearOrderItemAction(orderId) {
    return async (dispatch, getState, { client }) => {
        try {
            dispatch({
                type: CLEAR_ORDER_ITEM_START,
            });

            const { data } = await client.mutate({
                mutation,
                variables: {
                    orderId
                },
                refetchQueries: [{ query }]
            })

            if (data?.clearOrderedItems?.status === 200) {
                dispatch({
                    type: CLEAR_ORDER_ITEM_SUCCESS,
                });
            } else {
                dispatch({ type: CLEAR_ORDER_ITEM_ERROR });
            }
        } catch (error) {
            dispatch({
                type: CLEAR_ORDER_ITEM_ERROR,
                payload: {
                    error,
                },
            });
            return false;
        }
        return true;
    };
}